var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuStatistic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10848 8.50741H4.46797C3.90404 8.50741 3.44265 8.9244 3.44265 9.43407V17.4219C3.44265 17.9316 3.90404 18.3485 4.46797 18.3485H6.10848C6.6724 18.3485 7.1338 17.9316 7.1338 17.4219V9.43407C7.1338 8.91514 6.6724 8.50741 6.10848 8.50741Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7267 5.55144H11.1194C10.5668 5.55144 10.1148 5.96843 10.1148 6.4781V17.422C10.1148 17.9316 10.5668 18.3486 11.1194 18.3486H12.7267C13.2792 18.3486 13.7313 17.9316 13.7313 17.422V6.4781C13.7313 5.96843 13.2792 5.55144 12.7267 5.55144Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5025 2.59497H17.8311C17.2565 2.59497 16.7864 3.01197 16.7864 3.52163V17.4216C16.7864 17.9312 17.2565 18.3482 17.8311 18.3482H19.5025C20.0771 18.3482 20.5472 17.9312 20.5472 17.4216V3.52163C20.5472 3.01197 20.0771 2.59497 19.5025 2.59497Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40234 20.7511C3.40234 20.1666 3.87615 19.6928 4.46062 19.6928L19.5393 19.6928C20.1238 19.6928 20.5976 20.1666 20.5976 20.7511C20.5976 21.3355 20.1238 21.8093 19.5393 21.8093L4.46062 21.8093C3.87615 21.8093 3.40234 21.3355 3.40234 20.7511Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStatistic);
export default __webpack_public_path__ + "static/media/Menu_Statistic.58d8883b9489d6bacefbcbb2e908e67a.svg";
export { ForwardRef as ReactComponent };